<template>
  <main class="containers-page px-4 pt-3">
    <h1 class="mb-0">
      {{ $t('Containers') }}
    </h1>
    <dx-data-grid
      ref="containersGrid"
      :data-source="dataSource"
      :remote-operations="remoteOperations"
      :allow-column-reordering="true"
      :show-borders="true"
      :column-min-width="50"
      :column-auto-width="true"
      :allow-column-resizing="true"
      column-resizing-mode="widget"
      :hover-state-enabled="true"
      :on-row-dbl-click="onRowDblClick"
      @toolbar-preparing="onToolbarPreparing"
      @cell-prepared="onContainersCellPrepared"
    >
      <dx-column
        data-field="id"
        caption="ID"
        :visible="false"
        :allow-editing="false"
        :allow-search="false"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="container"
        :caption="$t('Container')"
        :fixed="true"
        fixed-position="left"
        :editor-options="{ maxLength: 15 }"
        :header-filter="{ searchEnabled: true }"
      />
      <dx-column
        data-field="freight_order"
        :caption="$t('shipping order')"
        :allow-search="true"
      />
      <dx-column
        data-field="company"
        :caption="$t('company')"
        :lookup="companyLookup"
        :allow-editing="false"
        :allow-search="false"
      />

      <dx-column
        data-field="freight_order_status"
        :caption="$t('Freight order status')"
        :lookup="statusLookup"
      />

      <dx-column
        data-field="port_freight_forwarding_status"
        :caption="$t('port freight forwarding status')"
        :allow-search="false"
        :allow-editing="false"
        data-type="string"
      />

      <dx-column
        data-field="port_freight_forwarding_date"
        :caption="$t('port freight forwarding status date')"
        :allow-search="false"
        :allow-editing="false"
        data-type="date"
      />

      <dx-column
        data-field="transit_decl_status"
        :caption="$t('transit decl status')"
        :allow-search="false"
        :allow-editing="false"
        data-type="string"
      />

      <dx-column
        data-field="transit_decl_date"
        :caption="$t('transit decl status date')"
        :allow-search="false"
        :allow-editing="false"
        data-type="date"
      />

      <dx-column
        data-field="start_tracking_date"
        :caption="$t('start tracking')"
        :allow-search="false"
        :allow-editing="user.is_manager"
        data-type="date"
      />
      <dx-column
        data-field="tracking_done"
        :caption="$t('tracking done')"
        :allow-search="false"
        :allow-editing="user.is_manager"
        data-type="boolean"
        :width="30"
      />
      <dx-column
        data-field="arrival_at_border_date"
        :caption="$t('arrival at border')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="commercial_documents_upload_date"
        :caption="$t('commercial documents upload date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="td_date"
        :caption="$t('td date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="td_control"
        :caption="$t('td control')"
        :allow-search="false"
      />
      <dx-column
        data-field="td_allowed_date"
        :caption="$t('td allowed date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="td_end_date"
        :caption="$t('td end date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="td_number"
        :caption="$t('td number')"
        data-type="string"
      />
      <dx-column
        data-field="railway_bill_filing_date"
        :caption="$t('railway bill filing date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="railway_accept_date"
        :caption="$t('railway accept date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="railway_loading_date"
        :caption="$t('railway loading date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="railway_trip_start_date"
        :caption="$t('railway trip start date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="railway_transport_number"
        :caption="$t('railway transport number')"
        :allow-search="false"
        data-type="string"
      />
      <dx-column
        data-field="railwaybill_number"
        :caption="$t('railwaybill number')"
        data-type="string"
        :allow-search="false"
      />
      <dx-column
        data-field="railway_trip_finish_date"
        :caption="$t('railway trip finish date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="dt_date"
        :caption="$t('dt date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="dt_number"
        :caption="$t('dt number')"
        data-type="string"
        :allow-search="false"
      />
      <dx-column
        data-field="dt_control"
        :caption="$t('dt control')"
        :allow-search="false"
      />
      <dx-column
        data-field="dt_allowed_date"
        :caption="$t('dt allowed date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="final_release_date"
        :caption="$t('final release date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="final_destination"
        :caption="$t('final destination')"
        :allow-search="false"
      />
      <dx-column
        data-field="location"
        :caption="$t('Location')"
        :editor-options="{ maxLength: 1000 }"
        :allow-search="false"
      />
      <dx-column
        data-field="location_date"
        :caption="$t('location date')"
        :allow-search="false"
        data-type="date"
      />
      <dx-column
        data-field="notes"
        :caption="$t('notes')"
        :editor-options="{ maxLength: 1000 }"
        :allow-search="false"
      />
      <dx-column
        data-field="create_date"
        :caption="$t('container creation date')"
        data-type="date"
        :allow-search="false"
        :allow-editing="false"
      />
      <dx-column
        data-field="author"
        :caption="$t('author')"
        :display-expr="(author) => author ? `${author.first_name} ${author.last_name}` : 'hi'"
        :allow-search="false"
        :allow-editing="false"
        cell-template="author"
      />
      <dx-column
        data-field="updated_by"
        :caption="$t('updated by')"
        :allow-search="false"
        :allow-editing="false"
        cell-template="updated_by"
      />
      <template #author="{ data }">
        {{ data.data.author ? `${data.data.author.first_name} ${data.data.author.last_name}` : '' }}
      </template>
      <template #updated_by="{data}">
        {{ data.data.updated_by ? `${data.data.updated_by.first_name} ${data.data.updated_by.last_name}` : '' }}
      </template>

      <template #pkg-pid-cell-template="{ data }">
        <a>
          {{ data.value }}
        </a>
      </template>

      <!-- <template #newContainerBtn="{ data }">
        <dx-button
          :text="$t('New container')"
          type="success"
          styling-mode="contained"
          class="custom-btn mr-2"
          @click="$router.push('/add-container')"
        />
      </template> -->

      <dx-group-panel :visible="true" />
      <dx-editing
        v-if="user.is_manager"
        :allow-updating="true"
        :allow-deleting="true"
        :allow-adding="isMobile"
        :use-icons="true"
        mode="row"
      />
      <dx-header-filter :visible="true" />
      <dx-search-panel
        :visible="true"
        :highlight-case-sensitive="false"
      />
      <dx-export
        :enabled="true"
        :allow-export-selected-data="true"
        file-name="containers"
      />
      <dx-column-chooser :enabled="true" />
      <dx-selection
        show-check-boxes-mode="always"
        mode="multiple"
      />
      <dx-state-storing
        :enabled="true"
        type="localStorage"
        :storage-key="`u${user.id}-container-grid-storage`"
      />
      <dx-paging :page-size="20" />
      <dx-pager
        :show-page-size-selector="true"
        :allowed-page-sizes="[10, 15, 20, 50]"
      />
    </dx-data-grid>
  </main>
</template>

<script>
import {
  DxDataGrid,
  DxExport,
  DxColumn,
  DxColumnChooser,
  DxEditing,
  DxHeaderFilter,
  DxGroupPanel,
  DxSearchPanel,
  DxSelection,
  DxStateStoring,
  DxPaging,
  DxPager,
} from 'devextreme-vue/data-grid';

import { mapState } from 'vuex';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale as localize, loadMessages } from 'devextreme/localization';

import mixinDetictingMobile from '@/mixins/mixin-detecting-mobile';

import createCustomStore from '@/utils/create-custom-store';
import createStatusLookup from '@/utils/create-status-lookup';
import createPackageStatusLookup from '@/utils/create-package-status-lookup';
import validateContainerNumber from '@/utils/container-number-validator';

export default {
  name: 'ContainersGrid',
  components: {
    DxDataGrid,
    DxColumn,
    DxGroupPanel,
    DxSearchPanel,
    DxEditing,
    DxHeaderFilter,
    DxExport,
    DxColumnChooser,
    DxSelection,
    DxStateStoring,
    DxPaging,
    DxPager,
  },
  mixins: [mixinDetictingMobile],
  data: vue => ({
    remoteOperations: {
      sorting: true,
      filtering: true,
      paging: true,
    },
    dataSource: createCustomStore('tracking/api/containers/'),
    statusLookup: createStatusLookup(vue),
    packageStatusLookup: createPackageStatusLookup(vue),
  }),
  computed: {
    ...mapState(['user']),
    companyLookup: () => ({
      dataSource: {
        store: createCustomStore('profile/api/companies/'),
        key: 'id',
      },
      valueExpr: 'id',
      displayExpr(company) {
        return company ? `${company.name} ${company.inn || ''}` : '';
      },
      allowClearing: true,
    }),
  },
  created() {
    loadMessages(ruMessages);
    localize(this.$i18n.locale);
  },
  methods: {
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        hint: this.$t('refresh'),
        options: {
          icon: 'ace-icon icon-refresh',
          hint: this.$t('refresh'),
          onClick: this.refreshDataGrid.bind(this),
        },
      }, {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-close',
          hint: this.$t('clear_filters'),
          onClick: this.clearFilter.bind(this),
        },
      });
    },
    onRowDblClick(e) {
      this.$router.push(`/containers/${e.data.id}`);
    },
    refreshDataGrid() {
      this.$refs.containersGrid.instance.refresh();
    },
    clearFilter() {
      this.$refs.containersGrid.instance.clearFilter();
    },
    onContainersCellPrepared(cell) {
      if (!cell.value) {
        return;
      }

      if (cell.rowType === 'data' && cell.column.dataField === 'container' && !validateContainerNumber(cell.value)) {
        cell.cellElement.classList.add('dx-validator', 'dx-datagrid-invalid');
      }
    },
  },
};
</script>

<style lang="scss">
.containers-page td.dx-command-select {
  min-width: 46px !important;
}
</style>
